import "../CSS/Header.css";
import { Link } from "react-router";

function Navbar() {
  return (
    <div className="nav">
      <div className="nav-container">
        <div className="logo">
          <Link className="h3" to={"/"}>
            Ahmed Samir
          </Link>
        </div>
        <div className="links">
          <span class="icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
          <ul>
            <li>
              <Link to={"/Portfolio"}>Portfolio</Link>
            </li>
            <li>
              <Link to={"/Resume"}>Resume</Link>
            </li>
            <li>
              <Link to={"/Contact"}>Contact me</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
export default Navbar;
